import { getRealmBlueprintAssetPath } from "@utils/getRealmBlueprintAssetPath";
import { MMONetworkSlave } from "@utils/types";
import { PickableItemStackData } from "mmo-common";
import { GameObject } from "realms-engine";
import { Render3DGameObject } from "realms-engine-browser";
import THREE from "realms-three";

export class SlavePickableItemStackGameObject
  extends GameObject
  implements MMONetworkSlave<"pickableItemStack">
{
  private render3D: Render3DGameObject;

  constructor(state: PickableItemStackData) {
    super();
    const sprite = new THREE.Sprite(
      new THREE.SpriteMaterial({
        map: new THREE.TextureLoader().load(
          getRealmBlueprintAssetPath(state.itemStack.item.asset)
        ),
      })
    );
    sprite.scale.set(5, 5, 1);
    sprite.center.set(0.5, 0);
    this.render3D = this.addChild(new Render3DGameObject(sprite));
    this.render3D.setPosition(state.position);
  }

  onSlaveChanges(
    changes: Partial<PickableItemStackData>,
    newState: PickableItemStackData
  ): void {
    if (changes.position !== undefined) {
      this.render3D.setPosition(newState.position);
    }
  }
}
